































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { Component, Prop } from 'vue-property-decorator';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import DeleteUserInner from  './delete-user-inner.vue';
import SelectedUserUnit from './selectedUserUnit.vue';
import { userTypes, EMPLOYEE, CUSTOMER } from './constant';
import {
  SwTable, TableColumnConfig, TableEntry, TableEntrySelectingEventData,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { UserTypes, ProductsList } from './types';
import _ from 'lodash';
const cssPrefix: string = 'deleteUser';
@Component({
  components: {
    DeleteUserInner,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SelectedUserUnit,
    SwButton,
    SwTable,
  },
})
export default class DeleteUser extends SwExtendedVue {

  cssPrefix: string = cssPrefix;

  @Prop({ type: Boolean, default: false })
  readonly displayPillarModal: Boolean;

  deleteUserData: any = {};
  selectedUser: string = '';

  userTobeDeleted: string = EMPLOYEE;

  deleteUserTypes: UserTypes  = _.cloneDeep(userTypes);
  currentStep: String = this.deleteUserTypes.EMPLOYEE.steps[0];

  get getPillarModalTitle(): string {
    return 'Delete User';
  }

  get getUsersList() {
    return [...this.deleteUserData.userList];
  }

  get getProductsList() {
    return [...this.deleteUserData.productsList];
  }

  get isEmployeeFirstStep(): boolean {
    return this.currentStep === this.deleteUserTypes.EMPLOYEE.steps[0].toString();
  }

  get isEmployeeSecondStep(): boolean {
    return this.currentStep === this.deleteUserTypes.EMPLOYEE.steps[1].toString();
  }

  get isEmployee(): boolean {
    return this.userTobeDeleted.includes(EMPLOYEE);
  }

  get isCustomer() : boolean {
    return this.userTobeDeleted.includes(CUSTOMER);
  }

  get productTableConfig(): TableColumnConfig[] {
    return [
      {
        key: 'selection',
        type: 'selection',
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        sorter: true,
        title:  this.$t('summary.serNo')
        .toString(),
      },
      {
        key: 'friendlyName',
        dataKey: 'friendlyName',
        sorter: true,
        title: this.$t('registerProduct.friendlyName')
        .toString(),
      },
      {
        key: 'productLine',
        dataKey: 'productLine',
        sorter: true,
        title: this.$t('myPromotions.prodLine')
        .toString(),
      },
    ];
  }

  get tableData(): TableEntry[] {
    const tableData: TableEntry[] = [];
    const rowTableData: ProductsList[] = _.cloneDeep(this.getProductsList);
    rowTableData.length > 0 &&
    rowTableData.forEach((element: ProductsList, index: number) => {
      tableData.push({
        _key: `tab${index}`,
        ...element,
      });
    });
    return tableData;
  }

  created(): void {
    // tslint:disable-next-line
    this.deleteUserData = JSON.parse(
      JSON.stringify(
        {
          userList: [
            {
              partyID: '1234189',
              emailAddress: 'adhage@sonicwall.com',
              fullName: 'Ambika12 Dhage',
            },
            {
              partyID: '1935552',
              emailAddress: 'pl1k@uy.com',
              fullName: 'pl1 k',
            },
            {
              partyID: '1935553',
              emailAddress: 'pl2k@sonicwall.com',
              fullName: 'pl 2',
            },
            {
              partyID: '1903133',
              emailAddress: 'SU_20201104987669@sonicwall.com',
              fullName: 'FirstName LastName',
            },
            {
              partyID: '1903118',
              emailAddress: 'SU_20201104987673@sonicwall.com',
              fullName: 'FirstName LastName',
            },
            {
              partyID: '1903131',
              emailAddress: 'SU_20201104987678@sonicwall.com',
              fullName: 'FirstName LastName',
            },
            {
              partyID: '1903132',
              emailAddress: 'SU_20201104987679@sonicwall.com',
              fullName: 'FirstName LastName',
            },
            {
              partyID: '1935116',
              emailAddress: 'testIU1@snwl.com',
              fullName: 'FirstName LastName',
            },
            {
              partyID: '1944057',
              emailAddress: 'ugissue1@sonicwall.com',
              fullName: 'UG Issue 1',
            },
            {
              partyID: '1944061',
              emailAddress: 'ugissue2@sonicwall.com',
              fullName: 'UG Issue 2',
            },
            {
              partyID: '1944189',
              emailAddress: 'testrenad2k@snwl.com',
              fullName: 'testrenad2 k',
            },
            {
              partyID: '1944190',
              emailAddress: 'testrenad3k@snwl.com',
              fullName: 'testrenad3 k',
            },
          ],
          productsList: [
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi1',
              productLine: 'EMAIL SECURITY 8300',
            },
            {
              serialNumber: '0017C5007865',
              friendlyName: 'testESAmbi100',
              productLine: 'EMAIL SECURITY 8300',
            },
          ],
        },
      ),
    );
    this.deleteUserData.userList = _.cloneDeep(this.getUsersList.map((ele: any) => {
      return {
        ...ele,
        selected: false,
      };
    }));
  }

  public onChangeUser(selectedUser: any): void {
    this.deleteUserData.userList = _.cloneDeep(this.getUsersList.map((ele: any) => {
      if (ele?.emailAddress?.indexOf(selectedUser) > -1) {
        this.setRenewalUser(selectedUser);
      }
      return {
        ...ele,
        selected: ele?.emailAddress?.indexOf(selectedUser) > -1 ? true : false,
      };
    }));
  }

  public onClickNext(): void {
    if (!this.deleteUserTypes.EMPLOYEE.selectedUser) {
      const message: string = 'Please select any User';
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: message });
      return;
    }
    this.currentStep = this.deleteUserTypes.EMPLOYEE.steps[1].toString();
  }

  public onClickBack(): void {
    this.currentStep = this.deleteUserTypes.EMPLOYEE.steps[0].toString();
  }

  private setRenewalUser(emailAddress: string) {
    this.deleteUserTypes.EMPLOYEE.selectedUser = emailAddress;
  }

  public onClickDelete(): void {
    if (this.deleteUserTypes.EMPLOYEE.selectedProducts.length === 0) {
      const message: string = 'Please select any products before deleting the User';
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: message });
      return;
    }
  }

  public onEntrySelecting(data: TableEntrySelectingEventData): void {
    if (data.selecting) {
      this.addProducts(data.entryKey);
    } else {
      this.removeProduct(data.entryKey);
    }
  }

  private addProducts(dataKey: string) : void {
    const selectedProductSerialNumber: string = this.tableData.find((entry: TableEntry) => {
      return entry._key === dataKey;
    })?.serialNumber || '';
    selectedProductSerialNumber &&
    this.deleteUserTypes.EMPLOYEE.selectedProducts &&
    this.deleteUserTypes.EMPLOYEE.selectedProducts.push(selectedProductSerialNumber);
  }

  private removeProduct(dataKey: string) : void {
    const removingProductSerialNumber: string = this.tableData.find((entry: TableEntry) => {
      return entry._key === dataKey;
    })?.serialNumber || '';
    const selectedSerialNumbers: string[] = this.deleteUserTypes.EMPLOYEE.selectedProducts || [];
    if (removingProductSerialNumber &&
      selectedSerialNumbers.length > 0) {
      this.deleteUserTypes.EMPLOYEE.selectedProducts = [
        ...(selectedSerialNumbers.filter((ele: string) => {
          ele !== removingProductSerialNumber;
        })),
      ];
    }
  }
}
